module.exports = __webpack_public_path__ + "static/media/five-point-dice.e091cdbf.svg";